module.exports = __webpack_public_path__ + "img/zhuanjiacode.71a0c857.png";